import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  title: string;
  description?: string;
  subDescription?: string;
  className?: string;
  headerRight?: React.ReactNode;
  /** Heading element for the title — pick to preserve the page's heading order. */
  titleTag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  dataCy?: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<ComponentProps> = ({
  title,
  description,
  subDescription,
  className,
  headerRight,
  titleTag: TitleTag = 'h5',
  dataCy,
  children,
}) => {
  const localClassName = classNames('section-card-container', className);
  return (
    <div className={localClassName} data-cy={dataCy}>
      <div className="section-card-header">
        <TitleTag className="section-card-title">{title}</TitleTag>
        {headerRight && <div className="section-card-header-right">{headerRight}</div>}
      </div>
      {description && <p className="section-card-description">{description}</p>}
      {subDescription && <p className="section-card-sub-description">{subDescription}</p>}
      <div>{children}</div>
    </div>
  );
};

export default SectionCard;
